<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Defining_an_Editor/Number_Projections';
    let nextLink= '/Documentation/Defining_an_Editor/Projections_for_Limited_Concepts';
    
    import Note from "$lib/notes/Note.svelte";
    import Figure from "$lib/figures/Figure.svelte";
</script>

<PrevNextSection {prevLink} {nextLink} />



<SectionComponent tag="h1" 
  id="string-projections-1"
  bind:intersecting={visibleById["string-projections-1"]}
  onIntersectChange={(visible) => setVisible("string-projections-1", visible)}
>String Projections</SectionComponent>
<p>String can be displayed as a single-line or multi-line text. </p>
<SectionComponent tag="h2" 
  id="single-line-2"
  bind:intersecting={visibleById["single-line-2"]}
  onIntersectChange={(visible) => setVisible("single-line-2", visible)}
>Single Line</SectionComponent>
<p>The single line display is the default, therefore there is no need to add any information other than
adding the string-typed property to the projection.</p>
<p>As an example, we used the <code>productName</code> property of the concept <code>InsuranceProduct</code>.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/language-main.ast#L53-L55

concept InsuranceProduct &#123;
    name: identifier;                       // internal name
    productName: string;                    // name by which this product is known to the public</code></pre>
<p>The property is displayed like this.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/editor-main-default.edit#L39-L39

Insurance Product $&#123;name&#125; ( public name: $&#123;productName&#125; ) USES $&#123;basedOn horizontal separator[, ]&#125;</code></pre>
<p>This produces the following result.</p>
<Figure
imageName={'documentation/Documentation-String-Projections-screenshot1.png'}
caption={'A single line string property'}
figureNumber={1}
/>
<SectionComponent tag="h2" 
  id="multi-line-3"
  bind:intersecting={visibleById["multi-line-3"]}
  onIntersectChange={(visible) => setVisible("multi-line-3", visible)}
>Multi-Line</SectionComponent>
<p>To indicate the use of a multi-line display add the keyword <code>multiline</code> to the projection.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/editor-main-comments.edit#L37-L37

Insurance Product $&#123;name&#125; ( public name: $&#123;productName&#125; ) USES $&#123;basedOn horizontal separator[, ]&#125;</code></pre>
<p>This results in the following.</p>
<Figure
imageName={'documentation/Documentation-String-Projections-screenshot2.png'}
caption={'A multi-line string property'}
figureNumber={1}
/>


<PrevNextSection {prevLink} {nextLink} />